import { useState, useRef, useEffect, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import DateFunc from '@/lib/lyg/date_func';
import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputWrite } from '@/pcomponents/common/date_picker/custom_input';
import SearchArea from "./area/search";
import strFunc from '@/lib/lyg/string';
import stu_getXcolumnJson from "@/pages/comp/basic/student/list/xcolumn/list";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import SupplyCardPosPopup from "./popup/supply_card_pos";
import SendCashReceiptPopup from "./popup/send_cash_receipt";
import SendPaytBySupplyPopup from "@/pages/comp/supply/payt/payt_supply/popup/send_payt_by_supply";
import AddCustomSupplyPopup from '@/pages/comp/supply/supply/popup/add_custom_supply';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import LoadingComponent from "@/pcomponents/common/content/loading";
import SupplyListExcelDown from "./area/excel_down";
import SupplyListFunc from "./func/list_func";

function SuppyListArea() {
  const xColumnArr = getXcolumnJson();
  const stuxColumnArr = stu_getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_date_type: 'a_date',
    s_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
    s_end_date: DateFunc.get_date_format(new Date(), "Y-m-t"),
    s_money_sum: "1",
    s_state: "",
    s_sort: "",
    s_stu_name_like: "",
    s_pay_sort: "",
    s_pay_is_card: "",
    s_pay_is_make_cash: "",
    s_memo_like: "",
    s_addon_user: "1",
    // s_addon_pos_card: "1",
    // s_addon_pos_receipt: "1",
    s_addon_trade_simple: "1",
    s_addon_payt: "1",
    s_addon_payt_cash: "1",
  });
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState<any>({ "tot": 0 });
  const SupplyListExcelDownRef = useRef<any>(null);
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });

  let select_stu_grade2_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade2' });

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "supply_card",//cash_receipt,send_payt_by_supply
    title: "팝업",
    row_data: null,
    is_cancel: false,
    supply_seq_arr: [],
    width: "800px",
    height: "70%",
  });

  useEffect(() => {

  }, []);

  const list = (inOptObj: any) => {
    let change_listOpt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(change_listOpt);
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/list', change_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          response.data["data"]["info_arr"] = SupplyListFunc.get_ordered_supply_info_arr({
            infoArr: response.data["data"]["info_arr"],
          });
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const goDelete = (e: any) => {
    let selected_row = ListComponentRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    //저장불가 체크
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      if (tmp_row["a_pay_sort"] == "payt") {
        if (tmp_row["payt_supply"]) {
          alert("결제선생 청구서는 삭제불가합니다.");
          return false;
        }
      }
    }

    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let form_data = {
      "data_arr": selected_row
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/delete', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: true,
            text: "삭제 되었습니다.",
          });
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const saveSelectedRow = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      is_request: true,
      is_reload: true,
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    //저장불가 체크
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      if (tmp_row["a_pay_sort"] == "payt") {
        if (tmp_row["payt_supply"]) {
          alert("결제선생 청구서는 수정불가합니다.");
          return false;
        }
      }
    }

    if (opt_obj.is_request) {
      if (!confirm("저장하시겠습니까?")) {
        return false;
      }
    }
    let form_data = {
      "data_arr": selected_row,
      "is_update": "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/write', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.is_reload) {
            list({});
          }
          if (opt_obj.is_request) {
            set_loading_data({
              is_display: true,
              text: "저장 되었습니다.",
            });
            setTimeout(() => {
              set_loading_data({
                ...loading_data,
                is_display: false,
              });
            }, 600);
          }
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (confirm("청구서를 전송하시겠습니까?(결제선생)") == false) {
      return false;
    }

    let supply_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "supply_seq_arr": supply_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/send_payt', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const open_send_payt_popup = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    let supply_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      
      if(tmp_row["a_money_sum"]==tmp_row["a_pay_money"]){
        alert("완납된 청구서는 청구서전송이 불가합니다."+tmp_row["a_title"]+" "+tmp_row["a_stu_name"]);
        return false;
      }

      if(!strFunc.is_empty(tmp_row["payt_supply"])){
        alert("이미 결제선생 청구서로 전송된 청구서가 있습니다."+tmp_row["a_title"]+" "+tmp_row["a_stu_name"]);
        return false;
      }

      let row_pri_val = tmp_row["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
    }

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "청구서전송",
      "sort": "send_payt_by_supply",
      supply_seq_arr: supply_seq_arr,
    });
  };

  const send_payt_resend_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (confirm("청구서를 재전송하시겠습니까?(결제선생)") == false) {
      return false;
    }

    let supply_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "supply_seq_arr": supply_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/send_payt_re', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_cancel_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      change_state: "cancel",//cancel,destroy
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    let confrim_msg = "청구서를 취소하시겠습니까?(결제선생)";
    if (opt_obj["change_state"] == "destroy") {
      confrim_msg = "청구서를 파기하시겠습니까?(결제선생)";
    }
    if (confirm(confrim_msg) == false) {
      return false;
    }

    let supply_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "supply_seq_arr": supply_seq_arr,
      change_state: opt_obj["change_state"],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/send_payt_cancel', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_send_read_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (confirm("청구서를 확인하시겠습니까?(결제선생)") == false) {
      return false;
    }

    let supply_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "supply_seq_arr": supply_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/send_read', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const check_payt_by_ajax = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    if (confirm("체크 하시겠습니까?") == false) {
      return false;
    }
    let form_data = {

    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/payt/check_payt_supply', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_send_cash_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (confirm("현금영수증발행을 하시겠습니까?(결제선생)") == false) {
      return false;
    }

    saveSelectedRow({ is_request: false, is_reload: false });

    let supply_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "supply_seq_arr": supply_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/send_payt_cash', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_send_cash_cancel_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (confirm("현금영수증을 취소 하시겠습니까?(결제선생)") == false) {
      return false;
    }

    let supply_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "supply_seq_arr": supply_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/send_payt_cash_cancel', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const send_payt_send_cash_read_by_ajax = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (confirm("현금영수증을 체크 하시겠습니까?(결제선생)") == false) {
      return false;
    }

    let supply_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let tmp_row = selected_row[i];
      let row_pri_val = tmp_row["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
    }

    let form_data = {
      "supply_seq_arr": supply_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/send_payt_cash_read', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const openSupplyCardPopup = (is_cancel: boolean) => {
    let selected_row = ListComponentRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    } else if (selected_row.length != 1) {
      alert("한개만 선택해주세요.");
      return false;
    }
    let row_data = selected_row[0];
    let pop_title = "카드결제";
    if (is_cancel) {
      pop_title = "카드결제(취소)";
    }

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      "row_data": row_data,
      "is_cancel": is_cancel,
      "sort": "supply_card"
    });
  };
  const openCashReceiptPopup = (is_cancel: boolean) => {
    let selected_row = ListComponentRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    } else if (selected_row.length != 1) {
      alert("한개만 선택해주세요.");
      return false;
    }
    let row_data = selected_row[0];
    let pop_title = "현금영수증";
    if (is_cancel) {
      pop_title = "현금영수증(취소)";
    }

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      "row_data": row_data,
      "is_cancel": is_cancel,
      "sort": "cash_receipt"
    });
  };

  const open_supply_custom_popup = () => {
    let supply_row_data = {};
    let pop_title = "청구서 커스텀 추가";

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      "sort": "add_custom_supply",
      stu_seq_arr: [],
      supply_row_data: supply_row_data,
    });
  };

  const go_excel_down_list = () => {
    if (SupplyListExcelDownRef.current) {
      SupplyListExcelDownRef.current.goExcelDown({
        infoArr: infoArr,
        xColumnArr: xColumnArr,
      });
    }
  };

  const onChangeRowInput = (params: any) => {
    if (params == undefined) { params = {}; }
    let optObj: any = {
      idx: 0,
      key: "",
      val: "",
    };
    for (let key in params) {
      optObj[key] = params[key];
    }

    let money_key_arr = ["a_money", "a_discount_money", "a_pay_money"];
    let sum_calculate_key_arr = ["a_money", "a_discount_money"];
    let tmp_info_arr: any = ListComponentRef.current.getRows();
    if (tmp_info_arr[optObj.idx] != undefined) {
      //값 변경하기
      let val_str = optObj.val;
      if (strFunc.str_in_array(optObj.key, money_key_arr) != -1) {
        val_str = strFunc.comma(val_str);
      }
      let row_pre_a_pay_money = tmp_info_arr[optObj.idx]["a_pay_money"];

      tmp_info_arr[optObj.idx][optObj.key] = val_str;

      //합계관련이면 합계 다시 계산
      if (strFunc.str_in_array(optObj.key, sum_calculate_key_arr) != -1) {
        let supply_money = parseInt(strFunc.uncomma(tmp_info_arr[optObj.idx]["a_money"]));
        let discount_money = parseInt(strFunc.uncomma(tmp_info_arr[optObj.idx]["a_discount_money"]));
        let sum_money = strFunc.comma(supply_money - discount_money);
        tmp_info_arr[optObj.idx]["a_money_sum"] = sum_money;
      }

      //완납이면 납부일도 변경
      if (tmp_info_arr[optObj.idx]["a_money_sum"]
        && strFunc.uncomma(tmp_info_arr[optObj.idx]["a_money_sum"]) == strFunc.uncomma(tmp_info_arr[optObj.idx]["a_pay_money"])) {
        //달라졋거나, 빈칸이면 적용
        if (strFunc.uncomma(row_pre_a_pay_money) != strFunc.uncomma(tmp_info_arr[optObj.idx]["a_pay_money"])
          || strFunc.is_empty(tmp_info_arr[optObj.idx]["a_pay_date"])
          || tmp_info_arr[optObj.idx]["a_pay_date"].substring(0, 4) == "0000") {
          tmp_info_arr[optObj.idx]["a_pay_date"] = DateFunc.get_date_format(new Date(), "Y-m-d");
        }
      }
    }

    setInfoArr(tmp_info_arr);
    ListComponentRef.current.setInfoArr([...tmp_info_arr]);
  };

  const onChangeDatePicker = (idx: number, key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    let tmp_info_arr: any = ListComponentRef.current.getRows();
    if (tmp_info_arr[idx] != undefined) {
      tmp_info_arr[idx][key] = date_str;
    }
    setInfoArr(tmp_info_arr);
    ListComponentRef.current.setInfoArr([...tmp_info_arr]);
  };

  const get_payt_btn_render = (params: any) => {
    let render_str: any = "";

    if (params.rowData.a_pay_sort == "payt") {
      if (params.rowData["payt_supply"]) {
        render_str = (
          <div className="text-center">
            {params.rowData["payt_supply"]["a_state"] == "send" &&
              <>
                <button className="btn-s btn-dark" onClick={() => {
                  setTimeout(() => {
                    send_payt_resend_by_ajax({});
                  }, 100);
                }} >재전송</button>
                <button className="btn-s btn-red ml-1" onClick={() => {
                  setTimeout(() => {
                    send_payt_cancel_by_ajax({ change_state: "destroy" });
                  }, 100);
                }} >파기</button>
              </>
            }
            {params.rowData["payt_supply"]["a_state"] == "complete" &&
              <button className="btn-s btn-red ml-1" onClick={() => {
                setTimeout(() => {
                  send_payt_cancel_by_ajax({});
                }, 100);
              }} >결제취소</button>
            }
            <button className="btn-s btn-gray ml-1" onClick={() => {
              setTimeout(() => {
                send_payt_send_read_by_ajax({});
              }, 100);
            }} >상태확인</button>
          </div>
        );
      } else {
        render_str = (
          <div className="text-center">
            {strFunc.is_empty(params.rowData.a_pay_money) &&
              <button className="btn-s btn-dark"
                onClick={() => {
                  setTimeout(() => {
                    open_send_payt_popup({});
                  }, 100);
                }} >청구서전송</button>
            }
          </div>
        );
      }
    } else if (params.rowData.a_pay_sort == "money") {
      if (params.rowData["payt_cash"]) {
        render_str = (
          <div className="text-center">
            {params.rowData["payt_cash"]["a_state"] == "complete" &&
              <button className="btn-s btn-red ml-1" onClick={() => {
                setTimeout(() => {
                  send_payt_send_cash_cancel_by_ajax({});
                }, 100);
              }} >현금영수증취소</button>
            }
            <button className="btn-s btn-gray ml-1" onClick={() => {
              setTimeout(() => {
                send_payt_send_cash_read_by_ajax({});
              }, 100);
            }} >상태확인</button>
          </div>
        );
      } else {
        render_str = (
          <div className="text-center">
            {!strFunc.is_empty(params.rowData.a_pay_money) &&
              <button className="btn-s btn-dark"
                onClick={() => {
                  setTimeout(() => {
                    send_payt_send_cash_by_ajax({});
                  }, 100);
                }} >현금영수증발급</button>
            }
          </div>
        );
      }
    }

    return render_str;
  };

  const cellClickedListener = useCallback((params: any) => {
    var key = params.colDef.field;
    if (key == "a_name") {

    }
  }, []);

  const cellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    let render_str = params.value;
    if (params.key == "a_stu_name") {
      let tmp_grade_str = "";
      if (select_stu_grade2_option_arr && params.rowData.stu_info != undefined) {
        for (let i = 0; i < select_stu_grade2_option_arr.length; i++) {
          if (select_stu_grade2_option_arr[i]["value"] == params.rowData.stu_info["a_stu_grade"]) {
            tmp_grade_str = select_stu_grade2_option_arr[i]["text"];
          }
        }
      }
      render_str = render_str + " " + tmp_grade_str;
    }
    if (params.key == "row_view_stu_grade") {
      if (params.rowData.stu_info != undefined) {
        render_str = params.rowData.stu_info["a_stu_grade"];
        if (stuxColumnArr.select_arr["a_stu_grade"] != undefined) {
          for (let i = 0; i < stuxColumnArr.select_arr["a_stu_grade"].length; i++) {
            if (stuxColumnArr.select_arr["a_stu_grade"][i]["value"] == render_str) {
              render_str = stuxColumnArr.select_arr["a_stu_grade"][i]["text"];
            }
          }
        }
      }
    } else if (params.key == "a_money" || params.key == "a_discount_money"
      || params.key == "a_pay_money" || params.key == "a_memo" || params.key == "a_pay_card_company"
      || params.key == "a_title") {

      let tmp_input_style: any = { width: "98%", textAlign: "right", fontSize: "14px", background: "transparent" };
      if (params.key == "a_memo" || params.key == "a_title") {
        tmp_input_style["textAlign"] = "left";
      }
      if (params.key == "a_pay_money") {
        tmp_input_style["width"] = 75;
      }

      let tmp_val_str = params.origin_val;
      if (params.key == "a_money" || params.key == "a_discount_money" || params.key == "a_pay_money") {
        tmp_val_str = strFunc.comma(tmp_val_str);
      }

      if (params.key == "a_pay_card_company") {
        tmp_input_style["textAlign"] = "left";
        if (params.rowData.a_pay_sort == "payt" && strFunc.is_empty(tmp_val_str)) {
          if (params.rowData["payt_supply"]) {
            tmp_val_str = params.rowData["payt_supply"]["a_appr_acquirer_nm"];
          }
        }
      }

      render_str = (
        <input type="text" className="row-input" style={tmp_input_style} value={tmp_val_str}
          onChange={(e: any) => {
            onChangeRowInput({
              idx: params.idx,
              key: params.key,
              val: e.target.value,
            });
          }} />
      );
      if (params.key == "a_pay_money") {
        let pay_div_style: any = {

        };
        if (params.rowData.a_pay_money == params.rowData.a_money_sum) {
          pay_div_style["background"] = "#5fff5f";
        }
        render_str =
          <div style={pay_div_style}>
            {render_str}
            <button className="btn-s btn-gray ml-1" onClick={() => {
              onChangeRowInput({
                idx: params.idx,
                key: params.key,
                val: params.rowData.a_money_sum,
              });
            }}>완납</button>
          </div>
      }
    } else if (params.key == "a_pay_date") {
      if (params.rowData.a_pay_money == params.rowData.a_money_sum) {
        let tmp_val = params.rowData[params.key];
        render_str = (
          <div style={{ display: "inline-block", width: 90 }}>
            <DatePicker
              selected={tmp_val != "" ? new Date(tmp_val) : null}
              onChange={(date: Date) => {
                onChangeDatePicker(params.idx, params.key, date);
              }}
              locale={ko}
              dateFormat="yyyy-MM-dd"
              customInput={<CustomInputWrite />}
              renderCustomHeader={customHeaderFunc}
            />
          </div>
        );
      } else {
        render_str = "";
      }
    } else if (params.key == "a_date") {
      if (params.rowData.a_pay_money != params.rowData.a_money_sum) {
        let tmp_val = params.rowData[params.key];
        render_str = (
          <div style={{ display: "inline-block", width: 90 }}>
            <DatePicker
              selected={tmp_val != "" ? new Date(tmp_val) : null}
              onChange={(date: Date) => {
                onChangeDatePicker(params.idx, params.key, date);
              }}
              locale={ko}
              dateFormat="yyyy-MM-dd"
              customInput={<CustomInputWrite />}
              renderCustomHeader={customHeaderFunc}
            />
          </div>
        );
      }
    } else if (params.key == "row_view_unpaid") {
      let sum_money = parseInt(strFunc.uncomma(params.rowData.a_money_sum));
      let pay_money = parseInt(strFunc.uncomma(params.rowData.a_pay_money));
      render_str = strFunc.comma(sum_money - pay_money);
    } else if (params.key == "a_pay_sort") {
      let tmp_input_style: any = { width: 80, textAlign: "left" };
      render_str = (
        <select style={tmp_input_style} value={params.origin_val}
          onChange={(e: any) => {
            onChangeRowInput({
              idx: params.idx,
              key: params.key,
              val: e.target.value,
            });
          }} >
          <option value="">선택없음</option>
          <option value="money">현금</option>
          <option value="card">카드기</option>
          <option value="payt">결제선생</option>
        </select>
      );
    } else if (params.key == "a_sort") {
      let tmp_input_style: any = { width: 80, textAlign: "left" };
      render_str = (
        <select style={tmp_input_style} value={params.origin_val}
          onChange={(e: any) => {
            onChangeRowInput({
              idx: params.idx,
              key: params.key,
              val: e.target.value,
            });
          }} >
          <option value="">선택없음</option>
          <option value="class">수업</option>
          <option value="etc">기타</option>
        </select>
      );
    } else if (params.key == "a_pay_is_card") {
      render_str = (
        <input type="checkbox" value={params.origin_val}
          checked={params.origin_val == "1" ? true : false}
          onChange={(e: any) => {
            let change_val = "";
            if (e.target.checked) {
              change_val = "1";
            }
            onChangeRowInput({
              idx: params.idx,
              key: params.key,
              val: change_val,
            });
          }} />
      );
    } else if (params.key == "a_money_sum") {
      render_str = strFunc.comma(render_str);
    } else if (params.key == "row_view_pay_btn") {
      if (params.rowData.a_pay_sort == "card") {
        if (strFunc.is_empty(params.rowData.a_pay_money)) {
          render_str = (
            <div className="text-center">
              <button className="btn-s btn-dark" onClick={() => { setTimeout(() => { openSupplyCardPopup(false); }, 100); }} >결제하기(pos)</button>
            </div>
          );
        } else {
          if (params.rowData.pos_card_arr && params.rowData.pos_card_arr.length > 0) {
            if (params.rowData.pos_card_arr[0]["a_state"] == "complete") {
              render_str = (
                <div className="text-center">
                  <button className="btn-s btn-red" onClick={() => { setTimeout(() => { openSupplyCardPopup(true); }, 100); }} >결제취소(pos)</button>
                </div>
              );
            }
          }
        }
      } else if (params.rowData.a_pay_sort == "money") {
        if (!strFunc.is_empty(params.rowData.a_pay_money)) {
          let is_exist_receipt = false;
          if (params.rowData.pos_cash_receipt_arr && params.rowData.pos_cash_receipt_arr.length > 0) {
            if (params.rowData.pos_cash_receipt_arr[0]["a_state"] == "complete") {
              is_exist_receipt = true;
              render_str = (
                <div className="text-center">
                  <button className="btn-s btn-red" onClick={() => { setTimeout(() => { openCashReceiptPopup(true); }, 100); }} >현금영수증취소(pos)</button>
                </div>
              );
            }
          }
          if (is_exist_receipt == false) {
            render_str = (
              <div className="text-center">
                <button className="btn-s btn-dark" onClick={() => { setTimeout(() => { openCashReceiptPopup(false); }, 100); }} >현금영수증발급(pos)</button>
              </div>
            );
          }
        }
      }
    } else if (params.key == "row_view_payt_btn") {
      render_str = get_payt_btn_render(params);
    } else if (params.key == "row_view_payt_url") {
      if (params.rowData.a_pay_sort == "payt") {
        if (params.rowData["payt_supply"]) {
          render_str = (
            <div className="text-center">
              {params.rowData["payt_supply"]["a_state"] == "send" &&
                <input type="text" readOnly
                  value={params.rowData["payt_supply"]["a_bill_url"]}
                  onChange={() => { }}
                  onClick={(e: any) => {
                    navigator.clipboard.writeText(e.target.value);
                    alert("복사되었습니다.");
                  }}
                  style={{ border: 0, width: "99%" }} />
              }
            </div>
          );
        }
      }
    } else if (params.key == "row_view_payt_phone") {
      if (params.rowData.stu_info && params.rowData.stu_info.link_user_arr && params.rowData.stu_info.link_user_arr.length > 0) {
        let par_link_info = params.rowData.stu_info.link_user_arr[0];
        if (par_link_info.par_info) {
          render_str = par_link_info.a_relation + " " + strFunc.getNumber2(par_link_info.par_info.a_user_phone);
        }
      }
      if (params.rowData.a_pay_sort == "payt") {
        if (params.rowData["payt_supply"]) {
          render_str = (
            <div className="text-center">
              {params.rowData["payt_supply"]["a_state"] == "send" &&
                <input type="text" readOnly
                  value={params.rowData["payt_supply"]["a_phone"]}
                  onChange={() => { }}
                  style={{ border: 0, width: "99%" }} />
              }
            </div>
          );
        }
      } else if (params.rowData.a_pay_sort == "money") {
        if (params.rowData["payt_cash"]) {
          render_str = (
            <span>{params.rowData["payt_cash"]["a_issuance_number"]}</span>
          );
        }
      }
    } else if (params.key == "row_view_manage") {
      render_str = (
        <span>
          <button className="btn-s btn-sky"
            onClick={() => {
              setTimeout(() => { saveSelectedRow({ selected_row: [params.rowData] }); }, 100);
            }}>저장</button>
        </span>
      );
    }

    return render_str;
  };
  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        saveSelectedRow={saveSelectedRow}
        open_send_payt_popup={open_send_payt_popup}
        open_supply_custom_popup={open_supply_custom_popup}
        goDelete={goDelete}
        list={list}
        countInfo={countInfo}
        go_excel_down_list={go_excel_down_list}
      ></SearchArea>
      <div className="mt-1">
        <ListComponent
          ref={ListComponentRef}
          infoArr={infoArr}
          xColumnArr={{ ...xColumnArr }}
          gridOpt={{
            is_add_idx_num: false,
            is_add_checkbox: true,
            td_align: "center",
            height:"auto",
            onGridReady: () => {
              list({});
            },
            onCellClicked: cellClickedListener,
            customCellRenderer: cellRenderer
          }}
        ></ListComponent>
      </div>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        onChangeNumPerPage={(num_per_page: number) => { list({ num_per_page: num_per_page, now_page: 1 }); }}></Paging>
      <div className="mt-1 text-right">
        {/* <button className="btn btn-dark" onClick={()=>{check_payt_by_ajax({});}}>
            결제선생 경제상태체크
          </button> */}
      </div>
      <SupplyListExcelDown
        ref={SupplyListExcelDownRef}
        infoArr={infoArr}
        xColumnArr={xColumnArr}
      ></SupplyListExcelDown>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "supply_card" &&
            <SupplyCardPosPopup
              row_data={popupData.row_data}
              is_cancel={popupData.is_cancel}
              list={list}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></SupplyCardPosPopup>
          }
          {popupData.sort === "cash_receipt" &&
            <SendCashReceiptPopup
              row_data={popupData.row_data}
              is_cancel={popupData.is_cancel}
              list={list}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></SendCashReceiptPopup>
          }
          {popupData.sort === "send_payt_by_supply" &&
            <SendPaytBySupplyPopup
              supply_seq_arr={popupData.supply_seq_arr}
              refresh_data={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></SendPaytBySupplyPopup>
          }
          {popupData.sort === "add_custom_supply" &&
            <AddCustomSupplyPopup
              stu_seq_arr={popupData.stu_seq_arr}
              supply_row_data={popupData.supply_row_data}
              refresh_data={list}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></AddCustomSupplyPopup>
          }
        </LayerPopup>
      }
    </div>
  );
}

export default SuppyListArea;